import styled from 'styled-components';

export const AddUserPopWrap = styled.div`
	color: #6c788c;
	color: red;
`;
export const AddPopWrap = styled.div`
	color: red;
	.ant-form-item {
		color: red;
	}
	color: #6c788c;
`;
export const FormWrap = styled.div`
	img {
		width: 54px;
		height: 54px;
		border-radius: 50%;
	}
`;
